import React, {Component} from 'react';
import Icon from "@material-ui/core/Icon";
import Button from "@material-ui/core/Button";
import ListDesignerHoc from "../../../../../HocHelpers/ListDesignerHoc";


class SampleData extends Component {
    render() {
        const {updateListData} = this.props;
        return (
            <div>
                <Button
                    onClick={updateListData}
                    variant={"contained"}
                    color={"primary"}>
                    Update Data
                    <Icon>update</Icon>
                </Button>
            </div>
        );
    }
}

export default ListDesignerHoc(SampleData);